import { css } from 'styled-components/macro';

export const InfoSectionHeaderButtonContainer = css`
  display: flex;
  gap: ${(props) => props.theme.spacing(8)};
`;

export const InfoSectionHeaderButton = css`
  && {
    padding: 4px ${(props) => props.theme.spacing(20)};
    background-color: ${(props) => (props.type === 'submit' ? props.theme.palette.darkOrange[75] : 'transparent')};
    color: ${(props) => (props.type === 'submit' ? props.theme.palette.white : props.theme.palette.blue[100])};
    border: ${(props) => (props.type === 'submit' ? 'none' : `1px solid ${props.theme.palette.blue[100]}`)};
    font-weight: 600;
  }
`;
